// 'use client';
// import { useState, useEffect } from 'react';

// const breakpoints: { [key: string]: string } = {
//     mobile: '(max-width: 600px)',
//     tablet: '(min-width: 601px) and (max-width: 1180px)',
//     smallLaptop: '(min-width: 1181px) and (max-width: 1700px)',
//     desktop: '(min-width: 1701px)'
// };

// const getMatchingBreakpoint = (): string | null => {
//     if (typeof window === 'undefined') {
//         return null;
//     }
//     for (const [key, value] of Object.entries(breakpoints)) {
//         if (window.matchMedia(value).matches) {
//             return key;
//         }
//     }
//     return null;
// };

// const useBreakpoint = (): string | null => {
//     const [breakpoint, setBreakpoint] = useState<string | null>(() => getMatchingBreakpoint());

//     useEffect(() => {
//         const handleResize = () => {
//             setBreakpoint(getMatchingBreakpoint());
//         };

//         if (typeof window !== 'undefined') {
//             window.addEventListener('resize', handleResize);
//             handleResize(); // Initialize the breakpoint on mount
//         }

//         return () => {
//             if (typeof window !== 'undefined') {
//                 window.removeEventListener('resize', handleResize);
//             }
//         };
//     }, []);

//     return breakpoint;
// };

// export default useBreakpoint;


'use client';
import { useState, useEffect } from 'react';

const breakpoints = {
    mobile: '(max-width: 600px)',
    tablet: '(min-width: 601px) and (max-width: 1180px)',
    smallLaptop: '(min-width: 1181px) and (max-width: 1700px)',
    desktop: '(min-width: 1701px)'
};

const getMatchingBreakpoint = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    for (const [key, value] of Object.entries(breakpoints)) {
        if (window.matchMedia(value).matches) {
            return key;
        }
    }
    return null;
};

const useBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState(() => getMatchingBreakpoint());

    useEffect(() => {
        const handleResize = () => {
            setBreakpoint(getMatchingBreakpoint());
        };

        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handleResize);
            handleResize();
        }

        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, []);

    return breakpoint;
};

export default useBreakpoint;
